var map = {
	"./album/routes.js": 481,
	"./alibi/routes.js": 478,
	"./dashboard/routes.js": 482,
	"./download/routes.js": 441,
	"./keyword/routes.js": 443,
	"./latest/routes.js": 445,
	"./placement/routes.js": 447,
	"./playlist/routes.js": 486,
	"./premium/routes.js": 453,
	"./project/routes.js": 484,
	"./report/routes.js": 461,
	"./setting/routes.js": 463,
	"./sfx/routes.js": 479,
	"./track/routes.js": 480
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 415;